import React, { useCallback } from 'react';
import { openShare } from 'utils/packages/rnShare';
import { TouchableOpacity } from 'react-native';
import { hitSlopS, Spacer } from 'design-system';
import { IconShareSquare } from 'design-system/icons/IconShareSquare';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { selectIsInvestWalkthroughActive } from 'reducers/selectors/walkthrough';
import { useStockMeta } from '../hooks';
const ShareStockInfoButton = ({ assetId }) => {
    const colors = useColors();
    const stockCache = useStockMeta(assetId);
    const isInvestWalkthroughActive = useAppSelector(selectIsInvestWalkthroughActive);
    const handleShare = useCallback(() => {
        if (stockCache?.name && stockCache?.symbol) {
            openShare({
                message: `${stockCache.name} is on @emma_finance. Always do your own research. Capital at risk. https://emma-app.com/stocks/${stockCache.symbol.toLowerCase()}`,
            });
        }
    }, [stockCache?.name, stockCache?.symbol]);
    if (stockCache?.name && stockCache?.symbol) {
        return (<>
        <Spacer w={16}/>
        <TouchableOpacity onPress={handleShare} hitSlop={hitSlopS} disabled={isInvestWalkthroughActive}>
          <IconShareSquare color={isInvestWalkthroughActive ? colors.elements.primaryOnModal : colors.text.primary}/>
        </TouchableOpacity>
      </>);
    }
    return null;
};
export default ShareStockInfoButton;
